import React, {Component} from 'react'
import { Redirect } from "react-router-dom"
import {ComponentType} from "../../constants/consts-component-type"
import {TypeRoute} from "../../constants/consts-prop-types"

class Contents extends Component {
  static propTypes = {
    currentRoute: TypeRoute,
  }

  constructor(props) {
    super(props)
    this.renderComponent = this.renderComponent.bind(this)
  }

  componentDidMount() {
    setTimeout(() => {
      // detect if user has just submitted a form, and if so scroll down to confirmation-element:
      const hasWordPressFormConfirmationElement = document.querySelector('.wpforms-confirmation-container-full')
      if(hasWordPressFormConfirmationElement) {
        const yPos = hasWordPressFormConfirmationElement.getBoundingClientRect().top - 30
        window.TweenLite.to(window, 1, {scrollTo: yPos, ease: window.Power2.easeInOut})
      }
    }, 1000)
  }

  renderComponent(componentData, idx) {
    if(!componentData || !componentData.component_id) return null

    // generate a React-component from 'component_id':
    const Component = ComponentType[componentData.component_id]

    return <Component
      key={idx}
      componentIndex={idx}
      data={componentData}
      currentRoute={this.props.currentRoute}
    />
  }

  render() {
    const {components} = this.props.currentRoute
    let isExpired = components[0]["post_expires"] && components[0]["post_expires"] < Math.round(Date.now()/1000)

    if (isExpired) {
      isExpired = false
      return <Redirect to="/" />
    }

    return (
      <React.Fragment>
        {components &&
        components.map((componentData, idx) => this.renderComponent(componentData, idx))
        }
      </React.Fragment>
    )
  }
}

export default Contents



// WEBPACK FOOTER //
// ./src/components/Contents/Contents.js